import { Box, Card, Typography } from '@mui/material'
import React from 'react'

const TotalProjectCountCard = ({employeeData}) => {
    return (
        <Card
            sx={{
                position: "relative",
                borderRadius: 3,
                height: "100px",
                overflow: "hidden",
                p: 1,
                color: "#fff",
                background: `linear-gradient(135deg, #646987 0%, #CDE1F1 100%)`, 
            }}
        >
            <Box
                sx={{
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    width: "100%",
                    height: "80%",
                    background: `url("data:image/svg+xml,%3Csvg viewBox='0 0 500 150' preserveAspectRatio='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0.00,49.98 C150.00,150.00 349.69,-50.00 500.00,49.98 L500.00,150.00 L0.00,150.00 Z' style='stroke:none; fill:rgba(255,255,255,0.3);'%3E%3C/path%3E%3C/svg%3E")`,
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover",
                }}
            ></Box>

            <Typography
                variant="subtitle1"
                sx={{ zIndex: 1, position: "relative", fontWeight: "bold" }}
            >
                Total Task
            </Typography>

            <Typography
                variant="h2"
                sx={{
                    zIndex: 1,
                    position: "absolute",
                    bottom: 16,
                    fontWeight: "bold",
                    color:'#fff'
                }}
            >
                {employeeData?.task_status_summary?.total_tasks}
            </Typography>
        </Card>
    )
}

export default TotalProjectCountCard
